<template>
  <div class="content" ref="line-chart"></div>
</template>

<script>
    import * as echarts from 'echarts';
    import {chartLineOption, chartColors, xLabelColor} from "./constant";

    export default {
        name: "LineEChartComponent", // 折线图

        props: {
            visualMap: {
                type: Boolean,
                default: false,
            },
            legend: {
                type: Object,
            },
            xData: {
                type: Array,
                required: true,
            },
            seriesData: {
                type: Array,
                required: true
            },
            series: {
                type: Array,
            }
        },

        mounted() {
            this.drawChart();
        },

        methods: {
            drawChart() {
                const myChart = echarts.init(this.$refs['line-chart']);
                let option = {};
                if (this.visualMap) {
                    option = {
                        visualMap: [{
                            show: false,
                            type: 'continuous',
                            seriesIndex: 0,
                            min: 0,
                            max: 400
                        }, {
                            show: false,
                            type: 'continuous',
                            seriesIndex: 1,
                            dimension: 0,
                            min: 0,
                            max: this.seriesData.length - 1
                        }],

                        tooltip: {
                            trigger: 'axis'
                        },
                        xAxis: [{
                            data: this.xData,
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                fontSize: 12,
                                color: xLabelColor[sessionStorage.getItem('theme')],
                            },
                            axisTick: {
                                show: false,
                            },
                        }],
                        yAxis: [{
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#999999',
                                }
                            },
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                fontSize: 12,
                                color: xLabelColor[sessionStorage.getItem('theme')],
                            },
                            splitLine: {
                                lineStyle: {
                                    color: '#999999',
                                }
                            }
                        }],
                        grid: {
                            bottom: '3%',
                            left: 0,
                            right: 0,
                            containLabel: true
                        },
                        series: [{
                            type: 'line',
                            showSymbol: false,
                            data: this.seriesData,
                        }]
                    };
                } else {
                    option = chartLineOption;
                    option.xAxis.axisLabel.color = xLabelColor[sessionStorage.getItem('theme')];
                    option.yAxis.axisLabel.color = xLabelColor[sessionStorage.getItem('theme')];
                    option.xAxis.data = this.xData;
                    option.color = chartColors;
                    option.legend.textStyle.color = xLabelColor[sessionStorage.getItem('theme')];
                    if (this.series) {
                        option.series = this.series;
                    } else {
                        option.series = this.handleSeries();
                    }
                }
                myChart.setOption(option);
            },

            handleSeries() {
                let series = [];
                for (let i = 0; i < this.seriesData.length; i++) {
                    let ser = {};
                    ser["name"] = this.seriesData[i].name;
                    ser["data"] = this.seriesData[i].data;
                    ser["type"] = "line";
                    series[i] = ser;
                }
                return series;
            }
        },
        watch: {
            '$store.state.theme': {
                handler: function (val) {
                    this.drawChart();
                }
            }
        },
    }
</script>

<style scoped>
  .content {
    width: 100%;
    height: 100%;
  }
</style>
